// 联系我们
import {Descriptions, Image} from "antd";

const ContactUs = () => {
    const info = [
        {
            key: '1',
            label: '邮箱',
            children: 'shengwupz@163.com',
            span: 3
        },
        {
            key: '2',
            label: '电话',
            children: '19923738232',
            span: 3
        },
        {
            key: '3',
            label: '地址',
            children: '重庆市两江新区礼嘉街道礼慈路37号',
            span: 3
        },
    ];

    return (
        <div>
            <h2>联系我们</h2>
            <Descriptions items={info}/>
            <Image
                width={320}
                src={process.env.REACT_APP_MAP_URI}
                preview={false}
            />
        </div>
    )
}

export default ContactUs